import { twJoin } from "tailwind-merge"
import React from "react"
import { Slide } from "react-slideshow-image"
import { slides } from "./data"
import Icon from "@components/UI/Icon"
import { SliderArrow } from "@components/SliderArrow/SliderArrow"

const Rating = ({ rating }: { rating: number }) => (
  <div className="flex text-yellow-400 text-2xl">
    {[...Array(5)].map((_, index) => {
      const starValue = index + 1
      return (
        <span key={index}>
          {rating >= starValue ? (
            <Icon
              name={"home-star"}
              size={19}
              color={"#"}
              className=""
            />
          ) : rating >= starValue - 0.5 ? (
            <Icon
              name={"home-half-star"}
              size={19}
              color={"#"}
              className=""
            />
          ) : (
            <Icon
              name={"home-star"}
              size={19}
              color={"#"}
              className="fill-neutral2-300"
            />
          )}
        </span>
      )
    })}
  </div>
)

export const CommentCard = ({
  title,
  description,
  signature,
  rating,
}: {
  title: string
  description: string
  signature: string
  rating: number
}) => (
  <div className={twJoin("p-6p 1024:p-12p h-full")}>
    <div
      className={twJoin(
        "shadow-[0px_2px_16px_0px_rgba(0,_0,_0,_0.1)]",
        "px-16p",
        "py-20p",
        "1024:p-24p",
        "1440:p-32p",
        "rounded-16p",
        "1024:rounded-24p",
        "bg-white flex flex-col gap-16p h-full"
      )}
    >
      <div className={twJoin("text-18p leading-36p", "1024:text-24p 1024:leading-40p font-600 text-neutral2-900")}>
        {title}
      </div>
      <div className={twJoin("text-14p leading-20p", "1024:text-18p 1024:leading-24p font-400 text-neutral2-900")}>
        {description}
      </div>
      <div
        className={twJoin("text-14p leading-20p", "1024:text-16p 1024:leading-24p font-400 text-neutral2-700 mt-auto")}
      >
        {signature}
      </div>
      <div>
        <Rating rating={rating} />
      </div>
    </div>
  </div>
)

export const Comments = () => (
  <section
    className={twJoin(
      "px-20p py-20p",
      "768:px-32p 768:py-32p",
      "1024:px-42p 1024:py-42p",
      "1440:px-120p 1440:py-60p",
      "bg-[linear-gradient(0deg,_#FFFFFF,_#FFFFFF)]",
      "bg-[linear-gradient(180deg,_#F5F5FF_0%,_#FFFFFF_100%)]",
      "mx-auto"
    )}
  >
    <div className={twJoin("1280:max-w-[1200px] mx-auto", "flex flex-col gap-y-32p 768:gap-y-64p")}>
      <div className={twJoin("text-center", "flex flex-col gap-y-24p")}>
        <h2 className={twJoin("text-26p", "1024:text-44p", "font-600 text-neutral2-900")}>
          See what users love about Traqq
        </h2>
      </div>
      <div>
        <Slide
          responsive={[
            {
              breakpoint: 704,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ]}
          autoplay={false}
          canSwipe={true}
          defaultIndex={0}
          duration={0}
          transitionDuration={400}
          arrows={true}
          prevArrow={
            <button className={"!left-[-25px]"}>
              <SliderArrow
                direction={"prev"}
                className={"hidden 1024:flex"}
              />
            </button>
          }
          nextArrow={
            <button className={"!right-[-25px]"}>
              <SliderArrow
                direction={"next"}
                className={"hidden 1024:flex"}
              />
            </button>
          }
        >
          {slides.map((item) => (
            <CommentCard
              key={`${item.title}-${item.signature}`}
              title={item.title}
              description={item.description}
              signature={item.signature}
              rating={item.rating}
            />
          ))}
        </Slide>
      </div>
    </div>
  </section>
)
